import React from 'react';
import { number, string, func, bool, objectOf } from 'prop-types';
import classnames from 'classnames';
import colornames from '../../../lib/colornames';
import { showError, handleOnSelectVariation, namespace } from '../utils';
import VariationsDropdown from '../variations-dropdown';
import customPropTypes from '../utils/proptypes';
import ApparelSizeSpecsComponents from './apparel-size-specs-components';
import VariationsTitle from './variations-title';
import { getDefaultVariationClassName, getTitleClassName } from '../utils/getVariationsClassName';
import VariationsSubtitle from './variations-subtitle';

const DropdownPicker = ({
  picker,
  pickerLabelId,
  selected_attributes,
  platform,
  onSelectVariation,
  selectedQuantity,
  hasDeferredErrors,
}) => {
  const hasError = showError(picker);
  const showOuterMessage = picker.outer_message && selected_attributes && !selected_attributes[picker.id];
  const showSelectedOption = !picker.outer_message && picker.selected_option;

  const getSelectedOption = () => {
    if (hasError) {
      return '';
    }
    if (showSelectedOption && picker.selected_option?.text) {
      return picker.selected_option.text;
    }
    if (showOuterMessage) {
      return picker.outer_message.text;
    }
    return '';
  };

  return (
    <div
      key={picker?.id}
      className={classnames(`${namespace}__picker`, {
        [`${namespace}__picker-size-specs-chart`]: picker?.size_specs_chart,
      })}
      data-testid="picker-container"
    >
      <div className={`${namespace}__title`}>
        {picker?.label && (
          <p className={getTitleClassName({ picker, namespace, hasError })}>
            <VariationsTitle
              label={picker.label?.text}
              pickerLabelId={pickerLabelId}
              namespace={namespace}
              value={{
                text: getSelectedOption(),
                className: getDefaultVariationClassName({
                  picker,
                  namespace,
                  hasError,
                  showSelectedOption,
                  showOuterMessage,
                }),
              }}
              error={{
                value: picker.error_message?.outer_message,
                show: hasError,
              }}
              icon={{
                show: picker.outer_message?.text_icon,
                id: picker.outer_message?.text_icon?.id,
                className: colornames(picker.outer_message?.text_icon?.color),
              }}
            />
            {picker.selected_option?.subtitle && (
              <VariationsSubtitle
                as="span"
                text={picker.selected_option?.text}
                className={classnames(`${namespace}__selected-title`, colornames(picker.selected_option))}
              />
            )}
          </p>
        )}
        {picker?.selected_subtitle && (
          <VariationsSubtitle
            className={classnames(`${namespace}__subtitle`, colornames(picker.selected_subtitle))}
            text={picker.selected_subtitle.text}
          />
        )}
      </div>
      <VariationsDropdown
        selectedAttributes={selected_attributes}
        handleOnSelectVariation={handleOnSelectVariation}
        onSelectVariation={onSelectVariation}
        picker={picker}
        selectedQuantity={selectedQuantity}
        hasDeferredErrors={hasDeferredErrors}
        platform={platform}
      />
      {picker?.apparel_size_specs && <ApparelSizeSpecsComponents picker={picker} />}
    </div>
  );
};

DropdownPicker.propTypes = {
  picker: customPropTypes.picker,
  pickerLabelId: string,
  selected_attributes: objectOf(string),
  platform: string,
  selectedQuantity: number,
  onSelectVariation: func.isRequired,
  hasDeferredErrors: bool,
};

export default DropdownPicker;
